var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelAppointmentCompletedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.004,
    height: 36,
    viewBox: "0 0 36.004 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M24.718,8.05A18,18,0,1,0,38.73,13.271,17.94,17.94,0,0,0,24.718,8.05Zm-5.081,7.067a4.52,4.52,0,0,1,3.182,1.336L26,19.635l3.182-3.182a4.5,4.5,0,1,1,6.364,6.364L32.366,26l3.182,3.182a4.5,4.5,0,1,1-6.364,6.364L26,32.363,22.82,35.545a4.5,4.5,0,1,1-6.364-6.364L19.638,26l-3.182-3.182a4.518,4.518,0,0,1,3.182-7.7Zm0,0",
    transform: "translate(-8 -8.001)",
    fill: "#d9152d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelAppointmentCompletedIcon);
export default __webpack_public_path__ + "static/media/cancelAppointmentCompletedIcon.3d01ec399e1c08966f85223986fb03c2.svg";
export { ForwardRef as ReactComponent };